import React, { useEffect, useMemo, useState } from 'react'
import Modal from 'react-modal'
import { useKonva } from '../../context/KonvaContext'
import ModalField from './ModalFileds'
import SuggestionTable from './SuggestionTable'
import { generateTurfDescription, totalPiecesCalculation } from '../../utils/calculationUtils'

const InputModal = (props) => {
  const { handleModalSubmit, validationError, handleCalculateClick } = props

  const { sideDimensions,
    setSideDimensions,
    modalIsOpen,
    setModalIsOpen,
    shapes,
    selectedShapeId,
    suggestDimension,
    setSuggestDimension,
    setSelectedDimension,
    setSelectedDimensionHistory,
    selectedDimesionHistory } = useKonva()

    const totalTurf = useMemo(() => selectedDimesionHistory && totalPiecesCalculation(selectedDimesionHistory?.originalWidth, selectedDimesionHistory?.height), [selectedDimesionHistory])

  const [customStyles, setCustomStyles] = useState({
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      maxHeight: '90%'
    },
  });

  const handleResize = () => {
    if (window.innerWidth < 768) {
      setCustomStyles({
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          width: '90vw',
          maxHeight: '90%'
        },
      });
    } else {
      setCustomStyles({
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          maxHeight: '90%'
        },
      });
    }
  };

  useEffect(() => {
    handleResize()
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setSideDimensions({
      ...sideDimensions,
      [name]: parseFloat(value),
    })
  }

  const handleClose = () => {
    setModalIsOpen(false)
    setSuggestDimension([])
    setSelectedDimension(null)
    setSelectedDimensionHistory(null)
  }

  const selectedShape = useMemo(() => {
    return shapes.find(({ id }) => id === selectedShapeId)
  }, [selectedShapeId, shapes])

  if (!selectedShape) return

  return (
    <Modal isOpen={modalIsOpen} onRequestClose={handleClose} style={customStyles}>
      <div className='inputModalWapper'>
        <h2>Enter Shape Dimensions</h2>
        <ModalField
          shapeType={selectedShape?.type}
          handleInputChange={handleInputChange}
          handleCalculateClick={handleCalculateClick}
        />
        <p className='noteModal'>Note: The turf rolls have a width of 15 feet. All calculations will be based on this standard width.</p>
        <div className='tableWrapper'>
          {suggestDimension && suggestDimension.length > 0 && (
            <>
              <h4 className='suggestHead'>Suggested Dimensions:</h4>
              <div className='suggestionTableWrapper'>
                <SuggestionTable />
              </div>
              {selectedDimesionHistory && (
                <h5 className='suggestHead'>
                  {generateTurfDescription(totalTurf)}
                </h5>
              )}
            </>
          )}
        </div>
        {validationError && <p className="errorMessage">{validationError}</p>}
        <div className='inputModalActionWrapper'>
          <div>
            <button onClick={handleModalSubmit} className='button1'>Submit</button>
          </div>
          <div>
            <button onClick={handleClose} className='button2'>Cancel</button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default InputModal
